import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

// Amplify読み込み
import { components, AmplifyEventBus } from "aws-amplify-vue";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

import store from "../store/index";

Vue.use(VueRouter);
Vue.use(AmplifyPlugin, AmplifyModules);

let user;

// ユーザー管理
getUser().then(user => {
  if (user) {
    router.push({ path: "/" });
  }
});

AmplifyEventBus.$on("authState", async state => {
  if (state === "signedOut") {
    user = null;
    store.commit("setUser", null);
    router.push({ path: "/login" });
  } else if (state === "signedIn") {
    user = await getUser();
    router.push({ path: "/" });
  }
});

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then(data => {
      if (data && data.signInUserSession) {
        store.commit("setUser", data);
        return data;
      }
    })
    .catch(() => {
      store.commit("setUser", null);
      return null;
    });
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/maths",
    name: "maths",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "maths" */ "../views/Maths.vue"),
    children: [
      {
        path: "ellipse",
        component: () =>
          import(/* webpackChunkName: "ellipse" */ "../views/Maths/Ellipse.vue")
      },
      {
        path: "fractal",
        component: () =>
          import(/* webpackChunkName: "fractal" */ "../views/Maths/Fractal.vue")
      },
      {
        path: "complex",
        component: () =>
          import(/* webpackChunkName: "complex" */ "../views/Maths/Complex.vue")
      },
      {
        path: "tessellation",
        component: () =>
          import(
            /* webpackChunkName: "tessellation" */ "../views/Maths/Tessellation.vue"
          )
      }
    ]
  },
  {
    path: "/music",
    name: "music",
    component: () =>
      import(/* webpackChunkName: "music" */ "../views/Music.vue")
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/about",
    name: "about",
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: "/login"
      });
    }
    return next();
  }
  return next();
});

export default router;
